/* Odds Comfort: Arabic currency. Shopify formats money with the store's one currency format ("LE 249" / "EGP 249"),
   which cannot change per language. On the Arabic site, show prices the Arabic way: "249 ج.م".
   Runs on the page and on everything the theme draws later (cards, bag, drawer, search, pop-ups). */
(function () {
  'use strict';
  if (document.documentElement.getAttribute('lang') !== 'ar') return;
  var RE = /(?:\bLE|\bEGP|E£)\s*(\d[\d.,]*)|(\d[\d.,]*)\s*(?:LE|EGP)\b/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, NOSCRIPT: 1, TEMPLATE: 1 };
  function fixNode(n) {
    var v = n.nodeValue;
    if (!v || (v.indexOf('LE') < 0 && v.indexOf('EGP') < 0 && v.indexOf('E£') < 0)) return;
    var out = v.replace(RE, function (m, a, b) { return (a || b) + ' ج.م'; });
    if (out !== v) n.nodeValue = out;
  }
  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { if (!SKIP[root.parentNode && root.parentNode.nodeName]) fixNode(root); return; }
    if (root.nodeType !== 1 || SKIP[root.nodeName]) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) { if (!SKIP[n.parentNode && n.parentNode.nodeName]) fixNode(n); }
  }
  function start() {
    walk(document.body);
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type === 'characterData') walk(m.target);
        else m.addedNodes.forEach(walk);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
